<template>
    <div>
        <div class="rounded-sm border border-gray-400 p-1">

          <!-- Numérotation -->
          <div class=" flex justify-between items-center">
            <div>
              <div class=" p-1">
                {{ idx + 1 }}.
              </div>
              <div class="handle cursor-grab"><i class="fas fa-arrows-alt"></i></div>
            </div>

            <div class=" text-2xl  w-1/2 text-center flex justify-center pt-2 ">
              <div class=" bg-green-600 rounded-sm p-1 w-full ">
                {{ f.title }}
              </div>
            </div>

            <div class=" pr-2 text-center">
              <i class="fas fa-times text-red-600 cursor-pointer hover:text-red-700"
                @click="del()">
              </i>
              <!-- Play button to run code -->
              <div class=" ">
                <button
                    :title="idx === 0 ? 'Tester la première fonction' : `Tester les ${idx + 1} premières fonctions` "
                    class=" text-white p-1 rounded-sm border-0 focus:outline-none"
                    :class="{ 'bg-green-600 hover:bg-green-700': f.isRunning,
                            'bg-gray-400 hover:bg-gray-500': f.isRunning === false}"
                    @click="() => clickedPlay(f)">
                  <i class="fas fa-play"></i>
                </button>
              </div>

              <!-- star button to star function -->
              <div>
                <button
                    :title="fonctionsFav.includes(f.functionKey) ? 'Retirer des favoris' : 'Ajouter aux favoris'"
                    class=" p-1 rounded-sm text-yellow-600 hover:text-yellow-700 border-0 bg-transparent focus:outline-none"
                    @click="() => toggleFunctionStar(func)">

                  <i v-show="!fonctionsFav.includes(f.functionKey)" class="far fa-star"></i>
                  <i v-show="fonctionsFav.includes(f.functionKey)" class="fas fa-star"></i>
                </button>
              </div>

            </div>
          </div>
          

          <div class=" text-sm mt-2 text-center" v-if="f.description">
            {{ f.description }}
            <i v-if="f.details" :id="'details-icon-' + f.uid" class="fas fa-info-circle text-gray-400 cursor-pointer"></i>
            <b-tooltip v-if="f.details" :target="'details-icon-' + f.uid" triggers="hover click" custom-class="long-tooltip">
              <span v-html="f.details"></span>
            </b-tooltip>
          </div>

          <div class="flex items-center justify-evenly space-x-2 py-2">

            <!-- Table -->
            <div class=" flex-grow">
              <table class=" w-full">
                <thead>

                  <tr>
                    <th class=" text-center">
                      <div v-show="f['origin'] !== undefined">
                        Origine
                      </div>
                    </th>
                    <th class=" text-center">
                      <div v-show="f['arguments'] !== undefined">
                        Arguments
                      </div>
                    </th>
                    <th class=" text-center">
                      <div v-show="f['target'] !== undefined">
                        Destination
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>

                    <!-- Origine -->
                    <td class=" w-1/3">
                      <div v-if="f['origin'] !== undefined" class=" flex justify-center px-2">
                        <excel_function_parameter
                          :func="f"
                          parameterKey="origin"
                          :availableColumns="availableColumnsList"
                          @change="(newValue, idx) => updateParameter('origin', newValue, idx)"
                          @delete="(idx) => f['origin'].splice(idx, 1) && update()"
                          @add="(value, defaultType) => f['origin'].push({ value: value, columnAutocomplete: true, type: defaultType}) && update()"/>
                      </div>
                    </td >

                    <!-- arguments -->
                    <td class=" w-1/3">
                      <div v-if="f['arguments'] !== undefined" class=" flex justify-center px-2">

                        <excel_function_parameter
                              :sl="f.functionKey == 'CONCATENER' ? true: false"
                              :func="f"
                              parameterKey="arguments"
                              :availableColumns="availableColumnsList"
                              :max-length="f.maxArguments"
                              :expected-arguments="f.expectedArguments"
                              @change="(newValue, idx) => updateParameter('arguments', newValue, idx)"
                              @delete="(idx) => f['arguments'].splice(idx, 1) && update()"
                              @add="(arg, defaultType) => addArgument(arg, defaultType)"/>
                      </div>
                    </td>

                    <!-- destination -->
                    <td class=" w-1/3">
                      <div v-if="f['target'] !== undefined" class=" flex justify-center px-2">
                        <excel_function_parameter
                            :func="f"
                            parameterKey="target"
                            :availableColumns="availableColumnsList"
                            @change="(newValue, idx) => updateParameter('target', newValue, idx)"
                            @delete="(idx) => f['target'].splice(idx, 1) && update()"
                            @add="(value, defaultType) => f['target'].push({ value: value, columnAutocomplete: true, type: defaultType }) && update()"/>
                      </div>
                    </td>

                  </tr>
                </tbody>
              </table>

              <div class=" mt-2 flex justify-center">
                <div class="" v-html="(getCodeForFunction()).displayCode">
                </div>
              </div>

              <div v-if="errorObject[idx]" class=" mt-2 flex justify-center">
                <span class=" text-red-700" :style="f.isRunning ? '': 'opacity: 0.5'"><b>Erreur: </b>{{ errorObject[idx].msg }}</span>
              </div>

              <div class=" mt-2 flex justify-center">
                <div class="">
                  <div class=" flex justify-center">
                    <b-button variant="info"
                      title="Afficher les résultats de cette fonction"
                      v-if="data.length > 0 && showFunctionTabulator"
                      @click="showFunctionTabulator = !showFunctionTabulator">
                      <i class="fas fa-eye"></i>
                    </b-button>
                    <b-button variant="info"
                      title="Afficher les résultats de cette fonction"
                      v-if="data.length > 0 && !showFunctionTabulator"
                      @click="showFunctionTabulator = !showFunctionTabulator">
                      <i class="fas fa-eye-slash"></i>
                    </b-button>
                  </div>
                  
                  <edit_tabulator
                  :style="'max-width: ' + (size * 0.9) + 'px'"
                  :extern_file="false"
                  v-show="data.length > 0 && showFunctionTabulator"
                  ref="play_test_tabulator"></edit_tabulator>
                </div>
              </div>
            </div>
            
          </div>
        </div>
    </div>
</template>

<script>
	import uniqueId from "lodash.uniqueid";
    
    import FunctionBlockToJS from "../../services/FunctionBlockToJS.js";
    import excel_function_parameter from "./excel_function_parameter.vue";
    import edit_tabulator from "../edit_tabulator.vue";

    var clone = require("clone");

    export default {
		components: {
            excel_function_parameter,
            edit_tabulator
        },
        props: {
            func: {

            },
            idx: {
                default: 0
            },
            errorObject: {},
            availableColumnsList: {},
            fonctionsFav: {
              default: () => [],
            },
            size: {}
        },
		data() {
			return {
                f: {},
                showFunctionTabulator: false,
                data: []
            }
        },
		watch: {
		},
		methods: {
            setShowFunctionTabulator(value)
            {
                this.f.showFunctionTabulator = value;
            },
            setIsRunning(value)
            {
                this.f.isRunning = value;
            },
            setData(data)
            {
                console.log("function - setData")
                this.data = data;

                this.$refs.play_test_tabulator.set_data(this.data);
            },
            clickedPlay()
            {
                this.$emit("play", this.idx);
            },
            toggleFunctionStar()
            {
                this.$emit("star", this.f.functionKey, !this.fonctionsFav.includes(this.f.functionKey));
            },
            del()
            {
                this.$emit("del", this.idx);
            },
            addArgument(argObject, defaultType)
            {
                if (typeof argObject === "string") {
                    argObject = { value: argObject, type: defaultType };
                }
                // type was decided in excel_function_parameter

                // {name: "Séparateur", value: " "}
                this.f.arguments.push(argObject);
                
                this.update();
            },
            getCodeForFunction(e)
            {
                let functionResult = FunctionBlockToJS.convertFunctionBlockToJS(this.f, true);
                return functionResult;
            },
            update()
            {
                console.log("update")
                this.$emit("update", this.f, this.idx)
            },
            updateParameter(key, value, idx)
            {
                this.f[key][idx] = value;

                this.update();
            }
        },
        mounted: async function () {
            this.f = clone(this.func);
        }
    }
</script>